export default __webpack_public_path__ + "static/Market-ef3001b682076a1db973eee012d0682d.png";